<template>
  <div class="main configurations">
    <div class="white-panel">
      <header class="panel-header space-between">
        <div>
          <router-link
            :to="{name: 'AdminPage'}"
            type="button"
            class="step-back"
            aria-label="Voltar atrás"
            title="Voltar atrás"
          />
          <h2 class="panel-title">
            {{ $t('manage.administrators') }}
          </h2>
        </div>

        <div>
          <div
            class="input-group"
          >
            <div class="input input-select">
              <div class="btn-select">
                <select
                  id="service-id"
                  v-model="serviceID"
                >
                  <option value="">
                    Sistema
                  </option>
                  <option
                    v-for="service in services"
                    :key="service.id"
                    :value="service.id"
                  >
                    {{ service.title['pt'] }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </header>

      <!-- Users -->
      <div class="system-users-list panel-scroll">
        <div
          v-for="user in users"
          id="system-user-1"
          :key="user.username"
          class="row row-small space-between system-user"
        >
          <div class="user-data flex-center">
            <div class="avatar">
              <img
                :src="`https://fenix.tecnico.ulisboa.pt/user/photo/${user.id}`"
                alt=""
              >
            </div>
            <div class="user-info">
              <div class="label-primary">
                {{ user.name }} <span>{{ user.id }}</span>
              </div>
            </div>
          </div>
          <div class="actions">
            <button
              type="button"
              class="btn-delete btn-tooltip link-modal"
              data-tooltip="Apagar"
              aria-label="Apagar"
              @click="openDeleteAdminModal(user)"
            />
          </div>
        </div>

        <!-- Criar utilizador -->
        <div class="row row-small">
          <button
            id=""
            type="button"
            class="btn-add-new link-modal"
            aria-haspopup="true"
            aria-expanded="false"
            @click="openAddAdminModal()"
          >
            {{ $t('add.administrator') }}
          </button>
        </div>
      </div>
    </div>
    <modal v-model="addAdminModal">
      <add-admin
        slot="modal-panel"
        v-model="addAdminModal"
        :type="type"
        :service="serviceID"
      />
    </modal>
    <modal v-model="deleteAdminModal">
      <delete-admin
        slot="modal-panel"
        v-model="deleteAdminModal"
        :admin="workingAdmin"
        :type="type"
        :service="serviceID"
      />
    </modal>
  </div>
</template>
<script>
import Modal from '@/components/utils/Modal'
import AddAdmin from '@/components/modals/AddAdmin'
import DeleteAdmin from '@/components/modals/DeleteAdmin'
import { mapActions, mapState } from 'vuex'
export default {
  components: {
    Modal,
    AddAdmin,
    DeleteAdmin
  },
  data () {
    return {
      serviceID: '',
      addAdminModal: false,
      deleteAdminModal: false,
      workingAdmin: undefined
    }
  },
  computed: {
    ...mapState([
      'users',
      'services'
    ]),
    type () {
      if (this.serviceID === '') {
        return 'admin'
      }
      return 'manager'
    }
  },
  watch: {
    serviceID: function (newserviceID, oldserviceID) {
      this.fetchUsers({ service: this.serviceID, type: this.type })
    }
  },
  created () {
    this.fetchUsers({ service: this.serviceID, type: this.type })
  },
  methods: {
    ...mapActions([
      'fetchUsers'
    ]),
    openAddAdminModal () {
      this.addAdminModal = true
    },
    openDeleteAdminModal (admin) {
      this.workingAdmin = admin
      this.deleteAdminModal = true
    }
  }
}
</script>
